import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Radio from './ComponentRadio';
const ComponentRadios = ({ name, options, selectedValue = null, onSelect, classNamesDefault = '', classNamesSelected = '' }) => (_jsx(_Fragment, { children: Object.keys(options).map((label) => (_jsx(Radio, { name: name, value: options[label], label: label, onSelected: () => onSelect(options[label]), classes: selectedValue === options[label] ? classNamesSelected : classNamesDefault }, options[label]))) }));
ComponentRadios.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.shape().isRequired,
    selectedValue: PropTypes.any,
    onSelect: PropTypes.func.isRequired,
    classNamesDefault: PropTypes.string,
    classNamesSelected: PropTypes.string
};
export default ComponentRadios;
